/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolSportsGolfIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-sports-golf"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12 16.63Q12 16.63 10.39 16.63Q8.78 16.63 6.51 14.36Q4.25 12.1 4.25 8.88Q4.25 5.65 6.51 3.39Q8.78 1.13 12 1.13Q15.22 1.13 17.49 3.39Q19.75 5.65 19.75 8.88Q19.75 12.1 17.49 14.36Q15.22 16.63 12 16.63ZM9.97 8.88Q9.97 8.88 10.19 8.88Q10.4 8.88 10.7 8.56Q11 8.25 11 7.83Q11 7.4 10.7 7.11Q10.4 6.83 9.97 6.83Q9.55 6.83 9.25 7.11Q8.95 7.4 8.95 7.83Q8.95 8.25 9.25 8.56Q9.55 8.88 9.97 8.88ZM14.05 8.88Q14.05 8.88 14.26 8.88Q14.47 8.88 14.78 8.56Q15.07 8.25 15.07 7.83Q15.07 7.4 14.78 7.11Q14.47 6.83 14.05 6.83Q13.63 6.83 13.32 7.11Q13.03 7.4 13.03 7.83Q13.03 8.25 13.32 8.56Q13.63 8.88 14.05 8.88ZM12.03 6.85Q12.03 6.85 12.24 6.85Q12.45 6.85 12.75 6.55Q13.05 6.25 13.05 5.83Q13.05 5.4 12.75 5.1Q12.45 4.8 12.03 4.8Q11.6 4.8 11.3 5.1Q11 5.4 11 5.83Q11 6.25 11.3 6.55Q11.6 6.85 12.03 6.85ZM10.68 22.82L10.68 21.8Q10.68 21.07 10.18 20.57Q9.68 20.07 8.95 20.07L7.78 20.07Q7.22 20.07 6.84 19.69Q6.45 19.3 6.45 18.75Q6.45 18.2 6.84 17.81Q7.22 17.43 7.78 17.43L16.25 17.43Q16.8 17.43 17.19 17.81Q17.57 18.2 17.57 18.75Q17.57 19.3 17.19 19.69Q16.8 20.07 16.25 20.07L15.07 20.07Q14.35 20.07 13.84 20.57Q13.32 21.07 13.32 21.8L13.32 22.82Z" fill={color} />
    </svg>
  );
}
